import axios from 'axios';

class APIClient {
  constructor() {
    const service = axios.create();
    service.interceptors.response.use(this.handleSuccess, this.handleError);
    this.service = service;
    this.basePath = process.env.REACT_APP_API_URL;
    this.jwtLocation = process.env.REACT_APP_LOCAL_JWT;
    this.organization = this.getOrganization();
    this.jwt = this.getJWTToken();
    this.apiHeaders = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.jwt}`,
        Organization: this.organization,
      },
    };
  }

  getJWTToken = () => {
    let jwtToken = '';
    Object.keys(localStorage).forEach((key) => {
      try {
        const values = JSON.parse(localStorage[key]);
        if (
          values?.secret
          && values?.credentialType?.toString().toLowerCase() === 'idtoken'
        ) {
          jwtToken = values.secret;
        }
      } catch (e) {
        if (key === this.jwtLocation && jwtToken === '') {
          jwtToken = localStorage[key];
        }
      }
    });

    return jwtToken;
  };

  getOrganization = () => {
    let organization = 'US';
    Object.keys(localStorage).forEach((key) => {
      if (key === 'Organization') {
        organization = localStorage[key];
      }
    });

    return organization;
  };

  handleSuccess = (response) => {
    return response;
  };

  handleError = (error) => {
    return Promise.reject(error);
  };

  getFeaturedProfileById(callback) {
    this.service
      .get(`${this.basePath}/v1/profiles/featured`, this.apiHeaders)
      .then((response) => {
        callback(response.status, response);
      })
      .catch((error) => {
        callback(error?.response?.status, {});
      });
  }
}

export default new APIClient();
